import { api } from "./api";


export async function getTransparencia() {
  const payload = [{ $sort:{ "created": -1} }];

  const { data } = await api.post("/database/transparencia_loja__c/aggregate", payload);
  return data;
}


export async function getAcessosPorAno(periodStart: number, periodEnd: number) {
  const payload = 
    {
        "periodStart": periodStart,
        "periodEnd": periodEnd
    };

  const { data } = await api.post("/find/acessosPorAno", payload);
  return data;
}

export async function getDesafios(periodStart: number, periodEnd: number) {
  const payload = 
    {
        "periodStart": periodStart,
        "periodEnd": periodEnd
    };
  const { data } = await api.post("/find/desafiosCriadosPorAno", payload);
  return data;
}

export async function getDesafiosConquistados(periodStart: number, periodEnd: number) {
  const payload = 
    {
        "periodStart": periodStart,
        "periodEnd": periodEnd
    };

  const { data } = await api.post("/find/desafiosConquistadoPorAno", payload);
  return data;
}

export async function getPontosDistribuidos(periodStart: number, periodEnd: number) {
  const payload = 
    {
        "periodStart": periodStart,
        "periodEnd": periodEnd
    };

  const { data } = await api.post("/find/pontosDistribuidosPorAno", payload);
  return data;
}

export async function getPremiosDistribuidos(periodStart: number, periodEnd: number) {
  const payload = 
    {
        "periodStart": periodStart,
        "periodEnd": periodEnd
    };

  const { data } = await api.post("/find/premiosDistribuidosPorAno", payload);
  return data;
}

export async function getTotaItensCadastradosLoja(periodStart: number, periodEnd: number) {
  const payload = 
    {
        "periodStart": periodStart,
        "periodEnd": periodEnd
    };

  const { data } = await api.post("/find/totalItensCadastradosPorAno", payload);
  return data;
}

export async function getRelelatorioAnaliticoResgates(periodStart: number, periodEnd: number) {
  const payload = 
    {
        "periodStart": periodStart,
        "periodEnd": periodEnd
    };
  
  const { data } = await api.post(
    "/find/relatorioAnaliticoResgates",
    payload,
    { headers: { Range: "items=0-10000" } }
  );
  return data;
}